import { all } from "redux-saga/effects";
import authSaga from "./authSaga";
import { qmsSaga } from "./qmsSaga";
import { qmsFolderStructureSaga } from "./qmsFolderStructureSaga";

export default function* rootSaga() {
  yield all([authSaga(), qmsSaga(), qmsFolderStructureSaga()]);
}
